import dynamic from 'next/dynamic'

export const DynamicSidebarMobileSkeleton = dynamic(() =>
	import('./SidebarMobileSkeleton').then(({ SidebarMobileSkeleton }) => SidebarMobileSkeleton)
)
